import { reactive } from 'vue';
import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from './FilterSelectionState';

export class FilterSelectionStateReactive {
	private readonly valuesByKey = reactive(new Map<FilterKey, string[]>());

	public getFor(key: FilterKey): readonly string[] {
		return this.valuesByKey.get(key) ?? [];
	}

	public isAnySelectedFor(key: FilterKey): boolean {
		return this.getFor(key).length > 0;
	}

	public isSelected(key: FilterKey, value: string): boolean {
		return this.getFor(key).includes(value);
	}

	public identifyAllPossibleFilterKeys(): readonly FilterKey[] {
		return Array.from(this.valuesByKey.keys());
	}

	public identifySelectedFilterKeys(): readonly FilterKey[] {
		return this.identifyAllPossibleFilterKeys().filter((key) => this.getFor(key).length > 0);
	}

	public replaceWith(other: FilterSelectionState): void {
		this.valuesByKey.clear();
		for (const [key, values] of other.reactive.valuesByKey.entries()) {
			this.set(key, values);
		}
	}

	public mergeWith(other: FilterSelectionState): void {
		for (const [key, values] of other.reactive.valuesByKey) {
			this.set(key, values);
		}
	}

	public set(key: FilterKey, values: readonly string[]): void {
		this.valuesByKey.set(key, [...values]);
	}

	public delete(key: FilterKey): void {
		this.valuesByKey.delete(key);
	}

	public clear(): void {
		this.valuesByKey.clear();
	}

	public refresh(): void {
		for (const [key, values] of this.valuesByKey) {
			this.set(key, values);
		}
	}
}
